import { render, staticRenderFns } from "./CostsCard.vue?vue&type=template&id=9a3b023e&"
import script from "./CostsCard.vue?vue&type=script&lang=js&"
export * from "./CostsCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports